import React, { useEffect, useState } from 'react'
import './compra.css'

import { vhostV1 } from '../funcoes';
import api from '../../services/api';
import ModalProduto from '../components/modalProduto/ModalProduto';
import ModalCriarProduto from './modalCriarProduto';
import ModalProdutoCompra from './modalProdutoCompra';
import { InputGroup, Modal } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';


function ModalAssociacao({isOpen,onRequestClose,prodAssociar
                         ,qtd, produto, cod_fornecedor, unidade, cod_produto_fornecedor}){
    const inputs = document.querySelectorAll("input, select");
    // Adicione um manipulador de eventos para o evento "keydown" em cada entrada ou select
    inputs.forEach(input => {
      input.addEventListener("keydown", e => {
        // Se a tecla pressionada for Enter
        if (e.key === "Enter") {
          e.preventDefault(); // evita que a tecla "Enter" envie um formulário, se aplicável

          // Obtenha o índice do elemento atual
          const currentIndex = Array.from(inputs).indexOf(e.target);
  
          // Mova o foco para o próximo elemento de entrada ou select
          const nextIndex = currentIndex + 1;
          if (nextIndex < inputs.length) {
            inputs[nextIndex].focus();
          }
        }
      });
    });

    let config = {
      headers: {
        'Authorization': localStorage.getItem("token")
      }
      }

  
    const [descricao, setDescricao] = useState('');
    const [codProduto, setCodProduto] = useState('');
    const [qtdPedido, setQtdPedido] = useState(0);
    const [qtdEmbalagem, setQtdEmbalagem] = useState(0);
    const [qtdUnitizada, setQtdUnitizada] = useState(0);
    const [isProdutoOpen, setIsProdutoOpen] = useState(false);
    const [isProdutoAddOpen, setIsProdutoAddOpen] = useState(false);
    const [vendaDefault, setVendaDefault] = useState(0);
    const [ncm, setNcm] = useState(0);
    const [compra, setCompra] = useState(0);
    const [msgErro, setMsgErro] = useState('');
    const [ProdNaoAssociado, setProdNaoAssociado] = useState(false);
    
    function closeModalProduto(){
      setIsProdutoOpen(false);
      
 }

const openModalAddProduto = () =>  setIsProdutoAddOpen(true);
  


 function closeModalAddProduto(){
  setIsProdutoAddOpen(false);
  
}

 function openModalProduto(){
  setIsProdutoOpen(true);
  
}
  
function obterQtd(codigoDesejado){
  let objetoEncontrado = produto?.find(produto => produto.COD_PRODUTO === codigoDesejado)

  if(objetoEncontrado){
    return objetoEncontrado.QTD;
  } else{
   
  }
}

let qty = obterQtd(prodAssociar);
useEffect(()=> {
  setQtdPedido(qty);
},[qty]);


useEffect(() => {
  if(qtdPedido > 0 && qtdEmbalagem > 0){
  setQtdUnitizada(Number(qtdEmbalagem) * Number(qtdPedido));
}
},[qtdEmbalagem, qtdPedido]);
    

    function buscaIten(){
      api.post(vhostV1('webcash/produto/retornaproduto/'+codProduto), {
        loja: localStorage.getItem('loja'),
        empresa: 0         
      },config)
      .then(function (response) { 
        
       if(response && response.data && response.data.dados){
        setDescricao(response.data.dados.DESCRICAO);
        setCodProduto(response.data.dados.COD_PRODUTO);
        setVendaDefault(response.data.dados.VENDA);
        

        
        
         }
       else{
        
       }  
        
       })
      .catch(function (error) {
       
        console.log(error);
                
      });
       };

       function requestClose(){
        setCodProduto('');
        setDescricao('');
        setQtdEmbalagem(0);
        setQtdPedido(0);
        setQtdUnitizada(0);
        onRequestClose();

       }



       useEffect( function (){
        api.post(vhostV1('webcash/produto/retornaproduto/'+prodAssociar), {
          loja: localStorage.getItem('loja'),
          empresa: 0         
        },config)
        .then(function (response) { 
          console.log(response);
         if(response && response.data && response.data.dados.length > 0){
          setDescricao(response.data.dados[0].DESCRICAO);
          setCodProduto(response.data.dados[0].COD_PRODUTO);
          setVendaDefault(response.data.dados[0].VENDA);
          
  
          
          
           }
         else{
           setCodProduto('');
           setDescricao('');
           setMsgErro('Não há produtos cadastrados com esse código!');
           setProdNaoAssociado(true);
           
         }  
          
         })
        .catch(function (error) {
         
          console.log(error);
                  
        });
         },[prodAssociar]);

         const sjson = {
          COD_PRODUTO_FORNECEDOR : cod_produto_fornecedor,
          COD_FORNECEDOR: cod_fornecedor,
          COD_PRODUTO: codProduto,
          QTD_FORNECEDOR: qtdEmbalagem,
          UN_FORNECEDOR: unidade,          
         }

         console.log(sjson);
         

         function associaProduto(){
          const sjson = {
            COD_PRODUTO_FORNECEDOR : cod_produto_fornecedor,
            COD_FORNECEDOR: cod_fornecedor,
            COD_PRODUTO: codProduto,
            QTD_FORNECEDOR: qtdEmbalagem,
            UN_FORNECEDOR: unidade,          
           }
          api.post(vhostV1('webcash/compras/associar/produto'), sjson, config)
          .then(function (response) { 
            console.log("Sucesso ao associar produto: ", response.data);
            setQtdEmbalagem(0);
            
           
            
           })
          .catch(function (error) {
           
            console.log(error);
                    
          });
          onRequestClose();
         }

          useEffect(() => {
                 const tooltipTriggerList = [].slice.call(
                     document.querySelectorAll('[data-bs-toggle="tooltip"]')
                 );
                 tooltipTriggerList.forEach((el) => new window.bootstrap.Tooltip(el));
             }, []);

  
         

    return (
      <Modal
      show={isOpen}
      onHide={onRequestClose}
      backdrop="static"
      keyboard={false}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
        <Modal.Title>Associação de Item</Modal.Title>
      </Modal.Header>

      <ModalProdutoCompra 
        isOpenMod={isProdutoOpen}
        onRequestClose={closeModalProduto}
        setCodProduto={setCodProduto}
        setDescricao={setDescricao}
        setVendaDefault={setVendaDefault}
        setCompra={setCompra}
        titulo="pesquisa de Produto"
      />

      <Modal.Body>
        <div className="container-fluid">
        <div className="row mb-3">
        <div className="d-flex align-items-center bg-white border rounded px-3 py-2">
        <div className="me-2">Código do Produto: {prodAssociar}</div>
         {ProdNaoAssociado && (
         <i
          className="bi-exclamation-circle-fill text-danger"
          title={msgErro}
          data-bs-toggle="tooltip"
         ></i>
        )}
     </div>
    </div>

        <div className="row">
          <div className="col-5">
          <label htmlFor="inputCodProduto" className="form-label">CODIGO</label>
          <div className="input-group mb-3">
            <input 
            name='inputCodProduto' 
            value={codProduto} 
            type="text" 
            onChange={(e) => setCodProduto(e.target.value)} 
            onBlur={buscaIten} 
            className="form-control"
            />
            <button className="btn btn-primary" onClick={openModalProduto} type="button">
            <i className="bi bi-search" style={{fontSize: "15px"}}></i>
            </button>
          </div>
          </div>

          <div className="col-7">
          <label htmlFor="inputDescricao" className="form-label">DESCRICAO</label>   
          <input  
            type="text"  
            className="form-control" 
            onChange={(e) => setDescricao(e.target.value)} 
            value={descricao} 
            id="inputDescricao"  
            required 
            readOnly
          />
          </div>

          <div className="col-4">
          <label htmlFor="inputQtdEmbalagem" className="form-label">QTD EMBALAGEM</label>   
          <input  
            type="text" 
            value={qtdEmbalagem} 
            onChange={(e) => setQtdEmbalagem(e.target.value)} 
            className="form-control" 
            id="inputQtdEmbalagem" 
            tabIndex="2" 
            required
          />
          </div>
        </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" onClick={requestClose} className="btn btn-outline-danger">
        Desistir
        </button>
        <button type="button" onClick={associaProduto} className="btn btn-success">
        Salvar
        </button>
      </Modal.Footer>
      
      </Modal>
    )
}



export default ModalAssociacao
